import React, { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";


export default function Error(){
const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return(
        <section id="error" style={{minHeight : '100vh',padding: '5em 0',color: 'black'}}>
            <nav id="menubar" className="navbar navbar-default navbar-fixed-top" role="navigation">
                <div className="container">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle" onClick={toggleMenu}>
                            <span className="sr-only">Toggle navigation</span> 
                            <span className="icon-bar"></span> <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                        </button>
                    </div>
                    <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="bruno-navbar-collapse">
                        <ul className="nav navbar-nav navbar-right">
                            <li><NavLink to ='/'>ACCUEIL</NavLink></li>
                        </ul>
                    </div>
                </div>    
            </nav>
            <div className="container">                
                <div className="page-header">
                    <h1 className="text-center">ERREUR 404</h1>
                </div>
                <div className="text-center">
                    <h3>RESSOURCE INTROUVABLE
                    <br/>
                    <br/>
                    VOUS VOUS ÊTES ÉGARÉS SUR LE SITE...</h3>
                </div>
            </div>
        </section>
    )



}